<template>
	<div>
		<h1>Base de données</h1>

		<div v-if="client">
			<b-button v-b-modal="'modal-credentials'">Identifiants</b-button
			>&nbsp;
			<b-button v-b-modal="'modal-tables'">Tables</b-button>
			<span v-if="user && user.env">&nbsp;
				<b-button variant="warning" @click="$router.push({ name: 'database_sync' })">
					⟳ Synchroniser depuis prod
				</b-button>
			</span>

			<b-modal
				:hide-footer="true"
				:id="'modal-credentials'"
				size="xl"
				title="Identifiants">
				<p>Retapez votre mot de passe</p>
				<b-input type="password" v-model="password"></b-input>
				<br />
				<b-button @click="getCredentials"
					>Récupérer identifiants</b-button
				>
				<br /><br />
				<div v-if="credentials == ''">Mauvais mot de passe</div>
				<div v-if="credentials == -1">Pas d'identifiants</div>
				<div v-if="credentials">
					<span>Serveur</span><br />
					<b-input v-model="credentials.host"></b-input>
					<span>Port (port 3306 si non précisé)</span><br />
					<b-input v-model="credentials.port"></b-input>
					<span>Base de données</span><br />
					<b-input v-model="credentials.database"></b-input>
					<span>Utilisateur</span><br />
					<b-input v-model="credentials.user"></b-input>
					<span>Mot de passe</span>
					<b-input v-model="credentials.password"></b-input>
					<span>API</span>
					<b-input v-model="credentials.api_host"></b-input>
					<span>API - Mot de passe</span>
					<b-input v-model="credentials.api_password"></b-input>
					<b-button @click="setCredentials"
						>Mettre à jour les identifiants</b-button
					>
				</div>
			</b-modal>

			<b-modal
				:hide-footer="true"
				:id="'modal-tables'"
				size="xl"
				:title="
					actions_row == -1
						? 'Tables'
						: 'Actions de la table ' + all_tables[actions_row].table
				">
				<div v-if="actions_row == -1 && actions_head == -1">
					<b-table
						thead-tr-class="d-flex"
						tbody-tr-class="d-flex"
						striped
						hover
						:items="all_tables"
						:fields="[
							{ key: 'table', class: 'col-sm-2' },
							{
								key: 'view',
								label: 'Visible',
								class: 'col-sm-1',
							},
							{
								key: 'column_date',
								label: 'Col date',
								class: 'col-sm-1',
							},
							{
								key: 'column_id',
								label: 'Col id',
								class: 'col-sm-1',
							},
							{
								key: 'description',
								label: 'Description',
								class: 'col-sm-4',
							},
							{
								key: 'actions',
								label: 'Actions',
								class: 'col-sm-1',
							},
							{
								key: 'actions_head',
								label: 'Iframe',
								class: 'col-sm-1',
							},
						]">
						<template v-slot:cell(table)="row">
							<b-form-input v-model="row.item.table" />
						</template>
						<template v-slot:cell(view)="row">
							<input type="checkbox" v-model="row.item.view" />
						</template>
						<template v-slot:cell(column_date)="row">
							<b-form-input v-model="row.item.column_date" />
						</template>
						<template v-slot:cell(column_id)="row">
							<b-form-input v-model="row.item.column_id" />
						</template>
						<template v-slot:cell(description)="row">
							<b-form-textarea v-model="row.item.description" rows="3"></b-form-textarea>
						</template>
						<template v-slot:cell(actions)="row">
							<b-button @click="actions_row = row.index"
								>{{ row.item.actions.length }}&nbsp;<i
									class="fas fa-wrench"></i
							></b-button>
						</template>
						<template v-slot:cell(actions_head)="row">
							<b-button @click="actions_head = row.index"
								>{{ row.item.actions_head.length }}&nbsp;<i
									class="fas fa-wrench"></i
							></b-button>
						</template>
					</b-table>
					<b-button @click="addTable">Ajouter table</b-button
					>&nbsp;&nbsp;
					<b-button @click="updateTable">Mettre à jour</b-button>
				</div>
				<div v-else-if="actions_head == -1">
					<b-table
						thead-tr-class="d-flex"
						tbody-tr-class="d-flex"
						striped
						hover
						:items="all_tables[actions_row].actions"
						:fields="[
							{
								key: 'project',
								label: 'Projet',
								class: 'col-sm-3',
							},
							{ key: 'name', label: 'Nom', class: 'col-sm-4' },
							{
								key: 'line',
								label: 'Afficher le nombres de lignes',
								class: 'col-sm-3',
							},
							{
								key: 'actions',
								label: 'Supprimer',
								class: 'col-sm-2',
							},
						]">
						<template v-slot:cell(project)="row">
							<b-form-select
								v-model="row.item.project"
								:options="projects_options" />
						</template>
						<template v-slot:cell(name)="row">
							<b-form-input v-model="row.item.name" />
						</template>
						<template v-slot:cell(line)="row">
							<b-form-checkbox v-model="row.item.line" />
						</template>
						<template v-slot:cell(actions)="row">
							<b-button
								variant="danger"
								@click="
									all_tables[actions_row].actions.splice(
										row.index,
										1
									)
								"
								><i class="fas fa-times"></i
							></b-button>
						</template>
					</b-table>
					<b-button
						@click="
							all_tables[actions_row].actions.push({
								project: '',
								name: '',
							})
						"
						>Ajouter une action</b-button
					>&nbsp;&nbsp;
					<b-button @click="actions_row = -1"
						>Revenir à la listes des tables</b-button
					>
				</div>
				<div v-else>
					<b-table
						thead-tr-class="d-flex"
						tbody-tr-class="d-flex"
						striped
						hover
						:items="all_tables[actions_head].actions_head"
						:fields="[
							{ key: 'url', label: 'Url', class: 'col-sm-6' },
							{ key: 'name', label: 'Nom', class: 'col-sm-4' },
							{
								key: 'actions',
								label: 'Supprimer',
								class: 'col-sm-2',
							},
						]">
						<template v-slot:cell(url)="row">
							<b-form-input v-model="row.item.url" />
						</template>
						<template v-slot:cell(name)="row">
							<b-form-input v-model="row.item.name" />
						</template>
						<template v-slot:cell(actions)="row">
							<b-button
								variant="danger"
								@click="
									all_tables[
										actions_head
									].actions_head.splice(row.index, 1)
								"
								><i class="fas fa-times"></i
							></b-button>
						</template>
					</b-table>
					<b-button
						@click="
							all_tables[actions_head].actions_head.push({
								url: '',
								name: '',
							})
						"
						>Ajouter un iframe</b-button
					>&nbsp;&nbsp;
					<b-button @click="actions_head = -1"
						>Revenir à la listes des tables</b-button
					>
				</div>
			</b-modal>

			<p>
				Nombre de lignes sur toutes les tables, sauf logs :
				{{ nb_lines }}
			</p>
			<b-form-input
				type="date"
				v-model="time"
				@change="updateChart"></b-form-input>
			<div v-for="(table, idx) in tables" :key="idx">
				<div v-if="table.column_date && table.last_entries">
					<h3>{{ table.name }}</h3>
					<p>{{ table.total }} lignes ajoutées</p>
					<div class="small">
						<line-chart
							:height="500"
							:key="print"
							v-if="print"
							:chart-data="table.last_entries"></line-chart>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import LineChart from "../services/LineChart.vue";
	import database from "../services/database.js";
	import projects from "../services/projects.js";
	import client from "../services/client.js";
	import users from "../services/users.js";
	import store from "../store";

	export default {
		name: "database_recap",
		components: {
			LineChart,
		},
		data() {
			return {
				client: null,
				tables: [],
				all_tables: [],
				print: 2,
				time: null,
				nb_lines: 0,
				password: "",
				credentials: null,
				actions_row: -1,
				actions_head: -1,
				list_projects: [],
				projects_options: [],
			};
		},
		computed: {
			user() {
				return store.state.user;
			}
		},
		methods: {
			async addTable() {
				this.all_tables.push({
					name: "",
					column_date: "",
					description: "",
					view: true,
					actions: [],
					actions_head: [],
				});
			},
			async updateTable() {
				var tables = [];

				for (var i = 0; i < this.all_tables.length; i++) {
					if (this.all_tables[i].view) {
						tables.push({
							name: this.all_tables[i].table,
							column_date: this.all_tables[i].column_date,
							column_id: this.all_tables[i].column_id || "",
							description: this.all_tables[i].description,
							actions: this.all_tables[i].actions,
							actions_head: this.all_tables[i].actions_head,
						});
					} else {
						tables.push({
							name: this.all_tables[i].table,
							description: this.all_tables[i].description,
							hide: true,
							actions: this.all_tables[i].actions,
							actions_head: this.all_tables[i].actions_head,
						});
					}
				}

				await client.put(tables);

				this.$router.go();
			},
			async setCredentials() {
				await client.put(
					null,
					null,
					null,
					null,
					null,
					this.credentials
				);
			},
			async getCredentials() {
				var credentials = await database.getCredentials(this.password);
				if (credentials.error) {
					this.credentials = "";
				} else {
					this.credentials = credentials.database;
					if (!this.credentials.port) this.credentials.port = "";
					if (this.credentials == {}) this.credentials = -1;
				}
			},
			async updateChart() {
				var diffTime = Math.abs(new Date(this.time) - new Date());
				var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

				if (diffDays > 1000) return;

				var dates = this.getDaysArray(new Date(this.time), new Date());

				var dates_label = [];
				for (var i = 0; i < dates.length; i++) {
					dates_label.push(dates[i].toLocaleDateString("fr-FR"));
				}

				for (var i = 0; i < this.tables.length; i++) {
					if (this.tables[i].column_date) {
						this.tables[i].last_entries = await database.get(
							"select",
							this.tables[i].name,
							{
								select:
									"count(*) AS nb_lines, date(" +
									this.tables[i].column_date +
									") AS date",
								end:
									this.tables[i].column_date +
									' >= "' +
									this.time +
									'" GROUP BY date(' +
									this.tables[i].column_date +
									")",
							}
						);
						this.tables[i].print = 0;
						var values = [];
						var dates = [];
						this.tables[i].total = 0;
						for (var j = 0; j < dates_label.length; j++) {
							values.push(0);
						}
						for (
							var j = 0;
							j < this.tables[i].last_entries.length;
							j++
						) {
							values[
								dates_label.indexOf(
									new Date(
										this.tables[i].last_entries[j].date
									).toLocaleDateString("fr-FR")
								)
							] = this.tables[i].last_entries[j].nb_lines;
							this.tables[i].total +=
								this.tables[i].last_entries[j].nb_lines;
						}
						this.tables[i].last_entries = {
							labels: dates_label,
							datasets: [
								{
									fill: false,
									label: "Lignes ajoutées",
									data: values,
									borderColor: "#0000ff",
									pointBackgroundColor: "#0000ff",
								},
							],
						};
					}
					this.print += 1;
				}
			},
			getRandomInt() {
				return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
			},
			getDaysArray: function (s, e) {
				for (
					var a = [], d = new Date(s);
					d <= e;
					d.setDate(d.getDate() + 1)
				) {
					a.push(new Date(d));
				}
				return a;
			},
		},
		created: async function () {
			if (
				store.state.user.rules &&
				store.state.user.rules.database == "désactivé"
			) {
				this.$router.push({ name: "profile" });
			}

			if (
				store.state.user.rules &&
				store.state.user.rules.database == "certaines tables"
			) {
				return;
			}

			let response = await users.getSelf(true);
			this.client = response.client;

			this.list_projects = await projects.getAll();
			for (var i = 0; i < this.list_projects.length; i++) {
				this.projects_options.push({
					value: this.list_projects[i]["uid"],
					text: this.list_projects[i]["libelle"],
				});
			}

			var key = [];
			this.all_tables = await database.get("show");
			if (this.all_tables.length > 0)
				key = Object.keys(this.all_tables[0]);
			var all_tables = {};
			for (var i = 0; i < this.all_tables.length; i++) {
				all_tables[this.all_tables[i][key]] = {
					table: this.all_tables[i][key],
					view: false,
					column_date: "",
					description: "",
					actions: [],
					actions_head: [],
				};
			}
			this.all_tables = all_tables;

			if (this.client.details && this.client.details.tables)
				this.tables = this.client.details.tables;

			this.time = new Date(
				new Date().getFullYear(),
				new Date().getMonth() - 2,
				new Date().getDate()
			)
				.toISOString()
				.substring(0, 10);

			this.updateChart();

			//var tables = await database.get("show");
			var tables = this.tables;
			this.nb_lines = 0;
			if (tables && tables.length > 0) {
				var child = [];
				for (var i = 0; i < tables.length; i++) {
					if (this.all_tables[tables[i].name]) {
						if (!tables[i].hide)
							this.all_tables[tables[i].name].view = true;
						if (tables[i].column_date)
							this.all_tables[tables[i].name].column_date =
								tables[i].column_date;
						if (tables[i].column_id)
							this.all_tables[tables[i].name].column_id =
								tables[i].column_id;
						if (tables[i].description)
							this.all_tables[tables[i].name].description =
								tables[i].description;
						if (tables[i].actions)
							this.all_tables[tables[i].name].actions =
								tables[i].actions;
						else this.all_tables[tables[i].name].actions = [];
						if (tables[i].actions_head)
							this.all_tables[tables[i].name].actions_head =
								tables[i].actions_head;
						else this.all_tables[tables[i].name].actions_head = [];

						if (tables[i].name != "logs") {
							var lines = await database.get(
								"SELECT",
								tables[i].name,
								{ select: "count(*)" }
							);
							if (lines && lines.length > 0) {
								this.nb_lines += lines[0]["count(*)"];
							}
						}
					} else {
						this.all_tables[tables[i].name] = tables[i];
						this.all_tables[tables[i].name].table = tables[i].name;
						if (!tables[i].hide)
							this.all_tables[tables[i].name].view = true;
					}
				}
			}

			var all_tables = [];
			var keys = Object.keys(this.all_tables);
			for (var i = 0; i < keys.length; i++) {
				all_tables.push(this.all_tables[keys[i]]);
			}
			this.all_tables = all_tables;
		},
	};
</script>

<style></style>
